import "../styles/loginlayout.scss";
import React, {useEffect, useState} from "react";
import Login from "../../../pages/components/login";

const LoginLayout = () => {
    useEffect(() => {
        document.body.style.backgroundColor = "#E5E5E5"
    }, [])
    const [step, setStep] = useState(0);
    return (
        <>
            <div className="container-fluid">
                <img src={require("../../../assets/images/Logo.png")} alt=""
                     style={{width: '200px', visibility: step === 0 ? "hidden" : "visible"}}
                     className="img-fluid me-5 mt-3 mb-4"/>
            </div>
            <div className="container">
                <Login step={step} setStep={setStep}/>
            </div>
        </>
    );
}

export default LoginLayout;